
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Saint-Maur-des-Fossés dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Saint-Maur-des-Fossés certifiée Google Partner, accompagne les entreprises saint-mauriennes pour booster leur visibilité en ligne et générer de nouveaux prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Saint-Maur-des-Fossés dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Saint-Maur-des-Fossés certifiée Google Partner, accompagne les entreprises saint-mauriennes pour booster leur visibilité en ligne et générer de nouveaux prospects.",
        },
      ],
    };
  },
};
